'use client';
import React from 'react';
import { makeStyles } from 'tss-react/mui';

import CheckIcon from '../../icons/Check';
import idsTokensDefault from '../../utils/tokens/idsTokens';
import withRef from '../../utils/withRef';
import { Checkbox } from '../Checkbox/Checkbox';
import MenuItem from '../MenuItem';

export const styles = ({ idsTokens = idsTokensDefault }) => ({
  root: {
    paddingLeft: '32px !important',
    paddingRight: '32px !important',
    alignItems: 'center',
    '&:hover': {
      backgroundColor: idsTokens.listItem.default.color.background.enabled,
    },
    '&:active': {
      backgroundColor: idsTokens.listItem.default.color.background.pressed,
      color: `${idsTokens.listItem.default.color.text.label.pressed} !important`,
    },
    '&.Mui-selected:not(:hover)': {
      backgroundColor: 'unset',
    },
  },
  multiple: {
    paddingLeft: `${idsTokens.listItem.default.spacing.standard.padding.left} !important`,
    '&:hover svg': {
      fill: idsTokens.checkbox.default.color.control.border.hover,
      '& rect': {
        fill: idsTokens.checkbox.default.color.control.background.unselected.hover,
      },
    },
    '&:active svg': {
      fill: idsTokens.checkbox.default.color.control.border.pressed,
    },
  },
  multipleSelected: {
    '&:hover svg': {
      fill: idsTokens.checkbox.default.color.control.background.selected.hover,
    },
  },
  check: {
    fontSize: '16px !important',
    padding: 2,
    boxSizing: 'content-box',
  },
  checkSmall: {
    fontSize: '14px !important',
    padding: 3,
    boxSizing: 'content-box',
  },
  checkbox: {
    minHeight: '18px !important',
    padding: 'unset',
    paddingLeft: 2,
  },
  hide: {
    display: 'block !important',
    height: '0px !important',
    minHeight: '0px !important',
    padding: '0px !important',
    color: 'transparent !important',
    border: 'none !important',
  },
  title: {
    background: `${idsTokens.listItem.default.color.background.enabled}`,
    paddingLeft: '32px !important',
    paddingRight: '32px !important',
    cursor: 'default',
    fontWeight: `${idsTokens.typography.font.weight.bold} !important`,
    color: `${idsTokens.listItem.default.color.text.label.enabled} !important`,
    opacity: 'unset !important',

    '&:hover': {
      background: `${idsTokens.listItem.default.color.background.enabled} !important`,
      color: `${idsTokens.listItem.default.color.text.label.enabled} !important`,
    },

    '&:focus': {
      border: '2px solid rgba(0,0,0,0) !important',
    },
    '&:active': {
      background: 'unset !important',
      color: `${idsTokens.listItem.default.color.text.label.enabled} !important`,
    },
  },
  titleMultiple: {
    paddingLeft: '40px !important',
  },
});

const useStyles = makeStyles()(styles);

export const SelectItem = ({
  selected,
  disabled,
  children,
  className,
  isPlaceholder,
  size,
  isTitle,
  multiple,
  forwardedRef: ref,
  ...rest
}) => {
  const { classes, cx } = useStyles();

  return (
    <MenuItem
      disableRipple
      selected={selected}
      disabled={isPlaceholder || disabled}
      className={cx(
        isTitle
          ? multiple
            ? cx(classes.title, classes.titleMultiple)
            : classes.title
          : classes.root,
        multiple && classes.multiple,
        multiple && selected && classes.multipleSelected,
        isPlaceholder && classes.hide,
        size === 'small' && 'Mui-sizeSmall',
        className
      )}
      {...rest}
      ref={ref}
    >
      {!multiple && selected && !(disabled || isPlaceholder || isTitle) && (
        <CheckIcon className={size === 'small' ? classes.checkSmall : classes.check} />
      )}
      {multiple && !isTitle && <Checkbox checked={selected} className={classes.checkbox} />}
      {children}
    </MenuItem>
  );
};

export default withRef()(SelectItem);
